import { BaseService } from './base.service';

export interface ISettingsService {
}
export class SettingsService extends BaseService implements ISettingsService {

  /**
   *
   */
  constructor() {
    super('settings');
  }

}



// WEBPACK FOOTER //
// ./src/services/settings.service.ts